import { render, staticRenderFns } from "./HeaderEditForm.vue?vue&type=template&id=52c25ec3&scoped=true&"
import script from "./HeaderEditForm.vue?vue&type=script&lang=js&"
export * from "./HeaderEditForm.vue?vue&type=script&lang=js&"
import style0 from "./HeaderEditForm.vue?vue&type=style&index=0&id=52c25ec3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c25ec3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52c25ec3')) {
      api.createRecord('52c25ec3', component.options)
    } else {
      api.reload('52c25ec3', component.options)
    }
    module.hot.accept("./HeaderEditForm.vue?vue&type=template&id=52c25ec3&scoped=true&", function () {
      api.rerender('52c25ec3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/survey-paper-manage/HeaderEditForm.vue"
export default component.exports